import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { EntryLine } from '~/api/common/types';
import type { UserLanguage } from '~/api/user/types';

import { useIntl } from '~/hooks/useIntl';

export const useFormatQuantity = (language: UserLanguage) => {
  const { formatDecimal } = useIntl(language);
  const { t } = useTranslation(['lines']);

  return useCallback(
    (line: EntryLine) =>
      line.unit === null
        ? formatDecimal(line.quantity)
        : `${formatDecimal(line.quantity)} ${t(`lines:units.${line.unit}`, { count: line.quantity }).toLowerCase()}`,
    [formatDecimal, t],
  );
};
